const CNAME = {
	BORDER: 'border',
	TOGGLE: 'on',
}

export default class GHeader {
	constructor(el) {
		el = el || document.querySelector('#gheader')
		if (!el) return

		this.e = el
		this.n = el.querySelector('nav')
		this.h = el.querySelector('.hamburger')

		if (this.h) this.h.onclick = this.toggle.bind(this)
		window.addEventListener('scroll', this.scroll.bind(this))
	}

	toggle() {
		this.h.classList.toggle(CNAME.TOGGLE)
		if (this.h.classList.contains(CNAME.TOGGLE)) this.open()
		else this.close()
	}

	open() {
		this.n.style.maxHeight = this.n.scrollHeight + 'px'
	}

	close() {
		this.n.style.maxHeight = null
	}

	scroll() {
		let y = window.pageYOffset
		if (y > 0) this.e.classList.add(CNAME.BORDER)
		else this.e.classList.remove(CNAME.BORDER)
	}
}
